import React from "react";
import dynamic from "next/dynamic";
import { FormattedDataType } from "@/templates/types";
import SectionCardWrapper from "@/templates/modern/elements/SectionCardWrapper";
import { Config } from "react-player";

const ReactPlayer = dynamic(() => import("react-player/lazy"), { ssr: false });

interface VideoCardProps {
  isSliderSection?: boolean;
  section: Partial<FormattedDataType>;
  link: FormattedDataType["links"][0];
}

const VideoCard: React.FC<VideoCardProps> = ({
  section,
  isSliderSection,
  link,
}) => {
  // Platform-specific config to support all video platforms
  const config: Config = {
    vimeo: {
      playerOptions: {
        dnt: true,
        controls: true,
      },
    },
  };

  return (
    <SectionCardWrapper
      isSlider={isSliderSection}
      data-test="link-card"
      background={section?.background}
    >
      <div className="w-full h-auto">
        <ReactPlayer url={link} width="100%" height="100%" config={config} />
      </div>
    </SectionCardWrapper>
  );
};

export default VideoCard;
